'use strict';
var parent = require('../../actual/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/assign.js
// module id = 630
// module chunks = 13